var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_14532_170793)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.8236,
    y: 17.8236,
    width: 42.3529,
    height: 42.3529,
    rx: 21.1765,
    stroke: "#0089EC",
    strokeWidth: 2.82353
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6177,
    y: 18.6177,
    width: 40.7647,
    height: 40.7647,
    rx: 20.3824,
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.6177,
    y: 18.6177,
    width: 40.7647,
    height: 40.7647,
    rx: 20.3824,
    stroke: "#E3F2FD",
    strokeWidth: 1.23529
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7889 30.1555V29.0444C44.6967 29.0473 46.5258 29.805 47.8768 31.1519C49.2279 32.4988 49.9912 34.3256 50 36.2333H48.8889C48.8889 35.4333 48.731 34.6412 48.4241 33.9023C48.1173 33.1635 47.6676 32.4925 47.1009 31.9278C46.5342 31.3631 45.8615 30.9159 45.1216 30.6118C44.3816 30.3077 43.5889 30.1526 42.7889 30.1555V30.1555ZM46.6556 36.2333H47.7667C47.7608 34.909 47.2322 33.6407 46.2957 32.7042C45.3593 31.7678 44.0909 31.2392 42.7667 31.2333V32.3444C43.7981 32.3444 44.7872 32.7542 45.5165 33.4835C46.2458 34.2128 46.6556 35.2019 46.6556 36.2333V36.2333ZM44.4333 36.2333H45.5444C45.5444 35.4966 45.2518 34.7901 44.7309 34.2691C44.2099 33.7482 43.5034 33.4555 42.7667 33.4555V34.5667C42.9864 34.5637 43.2044 34.6047 43.408 34.6874C43.6116 34.7701 43.7965 34.8928 43.9518 35.0482C44.1072 35.2035 44.2299 35.3884 44.3126 35.592C44.3953 35.7956 44.4363 36.0136 44.4333 36.2333ZM46.9778 43.5444L48.9111 45.4778L45.4222 48.9555L43.5556 46.9889L41.8889 48.6444L36.9667 43.8222L35.2111 45.5667H32.3778C32.223 46.077 31.9084 46.5242 31.4803 46.8422C31.0522 47.1603 30.5333 47.3325 30 47.3333V46.0555C30.1769 46.0897 30.3592 46.0844 30.5338 46.0399C30.7083 45.9955 30.8709 45.9129 31.0099 45.7983C31.1489 45.6836 31.2608 45.5396 31.3376 45.3766C31.4144 45.2137 31.4542 45.0357 31.4542 44.8555C31.4542 44.6754 31.4144 44.4974 31.3376 44.3345C31.2608 44.1715 31.1489 44.0275 31.0099 43.9128C30.8709 43.7982 30.7083 43.7156 30.5338 43.6712C30.3592 43.6267 30.1769 43.6213 30 43.6555V42.3444C30.5672 42.3449 31.1175 42.5373 31.5613 42.8903C32.0052 43.2434 32.3165 43.7363 32.4444 44.2889H34.6667L36.0333 42.9111L30.2222 37.0667V33.0555L36.3333 30.7444L48.0556 42.4778L46.9778 43.5444ZM46.0778 42.6444L46.2444 42.4778L36 32.2333L31.4889 33.9333V36.5333L41.8333 46.8778L42.5889 46.1222L46.0778 42.6444ZM46.0778 44.4555L44.4 46.1222L45.4222 47.1444L47.1 45.4778L46.0778 44.4555Z",
    fill: "#006FC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_14532_170793",
    x: -0.941177,
    y: -0.529413,
    width: 81.8824,
    height: 81.8824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.82353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.23529
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14532_170793"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41176
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.47059
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14532_170793",
    result: "effect2_dropShadow_14532_170793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_14532_170793",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.1b1434ea8281fa43eeb29e0767870a9e.svg";
export { ForwardRef as ReactComponent };